import IconSearch from '@picsart/icons/IconSearch';
import { useEffect, useState } from 'react';

import { ISingleToolSearchProps } from './types';
import SingleToolSearch from './SingleToolSearch';
import useStyles from './styles';

function SingleToolSearchDesktop(props: ISingleToolSearchProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    const minimizeSearch = () => {
      setIsExpanded(false);
    };

    window.addEventListener('click', minimizeSearch);

    return () => {
      window.removeEventListener('click', minimizeSearch);
    };
  }, []);

  return isExpanded ? (
    <SingleToolSearch {...props} />
  ) : (
    <IconSearch
      className={classes.collapsedIcon}
      onClick={(e) => {
        e.stopPropagation();
        setIsExpanded(true);
      }}
    />
  );
}

export default SingleToolSearchDesktop;
